import { apiBuilder } from "@zodios/core";
import { z } from "zod";

const mcpAuthorizeDetailsResponseSchema = z.object({
  app_name: z.string(),
  client_id: z.string(),
  redirect_uri: z.string(),
  response_type: z.string(),
});

const mcpAuthorizeGrantResponseSchema = z.object({
  redirect_uri: z.string(),
});

export const mcpOAuthApiDefinitions = apiBuilder({
  alias: "getMcpAuthorizeDetails",
  method: "get",
  path: "/auth/public-mcp/authorize/details",
  parameters: [
    { name: "client_id", type: "Query", schema: z.string().optional() },
    { name: "response_type", type: "Query", schema: z.string().optional() },
    { name: "redirect_uri", type: "Query", schema: z.string().optional() },
    { name: "state", type: "Query", schema: z.string().optional() },
    { name: "code_challenge", type: "Query", schema: z.string().optional() },
    { name: "code_challenge_method", type: "Query", schema: z.string().optional() },
  ],
  response: mcpAuthorizeDetailsResponseSchema,
})
  .addEndpoint({
    alias: "postMcpAuthorizeGrant",
    method: "post",
    path: "/auth/public-mcp/authorize/grant",
    parameters: [
      { name: "client_id", type: "Query", schema: z.string().optional() },
      { name: "response_type", type: "Query", schema: z.string().optional() },
      { name: "redirect_uri", type: "Query", schema: z.string().optional() },
      { name: "state", type: "Query", schema: z.string().optional() },
      { name: "code_challenge", type: "Query", schema: z.string().optional() },
      { name: "code_challenge_method", type: "Query", schema: z.string().optional() },
      {
        name: "body",
        type: "Body",
        schema: z.object({ allow: z.boolean() }),
      },
    ],
    response: mcpAuthorizeGrantResponseSchema,
  })
  .build();
